/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : CustomFiltersB.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */

import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Box, Menu, Typography, Divider } from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { CustomButton, SelectTextField } from "../index";

function CustomFiltersB({
  anchorEl,
  open,
  handleClose,
  mainOptionsList,
  selectedMainOption,
  handleFilterClick,
  onReset,
  onApplyNow,
}) {
  const [selectedMainField, setSelectedMainField] = useState(
    selectedMainOption || "",
  );

  useEffect(() => {
    setSelectedMainField(selectedMainOption || "");
  }, [selectedMainOption]);

  return (
    <Box sx={styles.mainContainer}>
      <CustomButton
        size="small"
        variant="contained"
        btnName="Filter"
        handleOnClick={handleFilterClick}
        btnStyle={styles.customButton}
        startIcon={<FilterAltIcon />}
      />
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          elevation: 12,
          sx: {
            mt: 0.4,
          },
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Typography sx={{ ...styles.heading, ml: "10px" }}>Filter</Typography>
        <Divider />
        <Box sx={styles.container}>
          <Box>
            <SelectTextField
              size="small"
              label="Select option"
              optionsList={mainOptionsList}
              selectedValue={selectedMainField}
              setSelectedValue={setSelectedMainField}
              variant="standard"
              sltFldStyle={styles.selectTextField}
            />
          </Box>

          <Box sx={styles.btBtnsContainer}>
            <CustomButton
              size="small"
              variant="contained"
              btnName="Reset All"
              handleOnClick={onReset}
            />
            <CustomButton
              size="small"
              variant="contained"
              btnName="Apply Now"
              disabled={!selectedMainField}
              handleOnClick={() => onApplyNow(selectedMainField)}
            />
          </Box>
        </Box>
      </Menu>
    </Box>
  );
}

CustomFiltersB.propTypes = {
  anchorEl: PropTypes.any,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  mainOptionsList: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
      type: PropTypes.string,
      value_options_list: PropTypes.array,
    }),
  ),
  selectedMainOption: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handleFilterClick: PropTypes.func,
  onReset: PropTypes.func,
  onApplyNow: PropTypes.func,
};

export default CustomFiltersB;

const styles = {
  mainContainer: {
  },
  container: {
    px: 1.4,
  },
  btBtnsContainer: {
    display: "flex",
    justifyContent: "space-between",
    mt: 3,
    mb: 0.4,
  },
  selectTextField: {
    width: "250px",
    mt: 1,
  },
  customTextFieldN: {
    width: "250px",
    mt: 1,
  },
  heading: {
    fontWeight: "bold",
  },
};
